import events from './events'
import store from 'reducers'
import Actions from './Actions'
import { 
    SelectedTimeSlotActions,
    SelectedPatientActions,
    FilterActions,
    AvailabilityActions,
    CompletedPageActions,
    SelectedCardActions 
} from 'actions'

export default class PageActions extends Actions{
    static get target(){
        return 'page'
    }

    static set(data){
        if(data == 'sessions'){
            if(Object(store.getState().session).accountID){
                super.set('filters')
            } else {
                super.set('loginOrSignup')
            }
        } else {
            super.set(data)
        }
    }

    static navToLogin(){
        this.set('login')
        CompletedPageActions.append('loginOrSignup')
    }
    
    static navToProfileSelect(){
        this.set('profileSelect')
        CompletedPageActions.append('profileSelect')
    }

    static navToPasswordReset(){
        this.set('passwordReset')
        CompletedPageActions.append('login')
    }

    static navToResetPasswordPrompt(){
        this.set('resetPasswordPrompt')
        CompletedPageActions.append('login')
    }

    // static navToSignup(){
    //     this.set('')
    //     CompletedPageActions.append('timeSlots')
    // }

    static navToFilters(){
        this.set('filters')
        CompletedPageActions.append('loginOrSignup')
    }

    static navToTimeSlots(){
        this.set('timeSlots')
        CompletedPageActions.append('timeSlots')
    }

    static navToCollectInformation(){
        this.set('collectInformation')
        CompletedPageActions.append('collectInformation')
    }

    static navToConfirmation(){
        this.set('confirmation')
        CompletedPageActions.append('confirmation')
    }

    static navToPayment(){
        this.set('payment')
        CompletedPageActions.append('payment')
    }

    static navToReceipt(){
        this.set('receipt')
        CompletedPageActions.append('receipt')
    }

    static navToEmptyPage(){
        this.set('empty')
    }

    static reset(){
        this.set('sessions')
        SelectedTimeSlotActions.clear()
        SelectedPatientActions.clear()
        FilterActions.reset()
        CompletedPageActions.reset()
        AvailabilityActions.clear()
        SelectedCardActions.clear()
    }
}


// WEBPACK FOOTER //
// ./actions/PageActions.js